import common from './data/common.json'
import cookie from './data/cookie.json'
import devices from './data/devices.json'
import family from './data/family.json'
import footer from './data/footer.json'
import guide from './data/guide.json'
import intro from './data/intro.json'
import language from './data/language.json'
import menu from './data/menu.json'
import notice from './data/notice.json'
import place from './data/place.json'
import policy from './data/policy.json'
import privacy from './data/privacy.json'
import profile from './data/profile.json'
import scloud from './data/scloud.json'
import security from './data/security.json'
import service from './data/service.json'
import signIn from './data/sign-in.json'

export let translationMap = {}
Object.assign(
  translationMap,
  common,
  cookie,
  devices,
  footer,
  guide,
  intro,
  language,
  menu,
  notice,
  place,
  policy,
  privacy,
  profile,
  scloud,
  security,
  service,
  family,
  signIn
)
